
import { Options, Vue } from "vue-class-component";

@Options({})
export default class CapitoleLoader extends Vue {
  logoUrl = `${process.env.BASE_URL}IconeCapitole.svg`;
}
